module.exports = __webpack_public_path__ + "img/banner1.0d924455.jpg";